<template>
  <div
    @click="
      () => {
        dataOnCardClick(dataIndex);
      }
    "
    :class="addressCardClass ? addressCardClass : 'addressCard'"
  >
    <Observer
      v-if="dataApplyObserver"
      :keepConnectedOnIntersection="true"
      :options="{ rootMargin: '-100px' }"
      @intersect="
        () => {
          dataOnIntersection(dataIndex);
        }
      "
    />
    <h1 class="couponTitle bold">{{ dataTitle }}</h1>
    <p class="fs-12 color-slaty takeAwayAddress lh16 mt8 mb12">
      {{ dataAddress }}
    </p>
    <hr v-if="!removeHorizontalLine" class="line mb12" />
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <img
          :src="
            dataIsStoreOpen
              ? staticImgBaseUrl + '/images/global/outlet-status.svg'
              : ''
          "
        />
        <p class="fs-11 color-slaty pl4">
          {{ dataIsStoreOpen ? "OPEN" : "CLOSED" }}
        </p>
        <img
          :src="staticImgBaseUrl + '/images/global/Line 59.svg'"
          class="pl8"
        />
        <img
          :src="staticImgBaseUrl + '/images/global/address-marker.svg'"
          class="pl8 pr4"
        />
        <p class="fs-11 color-slaty">
          {{ dataDistance }} Km
          <span v-if="deliveryTimeInMin > 0"
            >({{ deliveryTimeInMin }} min ride)</span
          >
        </p>
      </div>
      <div>
        <button
          v-if="dataActionCta"
          class="btn medium bold takeaway-btn"
          @click="handleOrderTypeStoreSelected(dataStoreId)"
        >
          {{ dataActionCta }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { staticImgBaseUrl } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { EVENT_CLICK_RESTAURANT_SELECTION } from "../helpers/analyticsEvents";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { OrderTypesFromCode } from "./../helpers/orderTypesConstants";
import Observer from "./Observer.vue";

export default {
  name: "AddressCard",
  components: {
    Observer,
  },
  props: {
    dataItem: { required: false, default: "" },
    dataTitle: { required: false, default: "" },
    dataAddress: { required: false, default: "" },
    dataIsStoreOpen: { required: false, default: true },
    dataDistance: { required: false, default: "" },
    dataActionCta: { required: false, default: "" },
    dataTime: { required: false, default: "" },
    removeHorizontalLine: { required: false, default: false },
    addressCardClass: { required: false, default: "" },
    dataStoreId: { required: false, default: "" },
    dataIndex: { required: false, default: 0 },
    dataContainerType: { required: false, default: "list" },
    dataApplyObserver: { required: false, default: false },
    dataOnIntersection: { required: false, default: () => {} },
    dataOnCardClick: { required: false, default: () => {} },
  },
  data() {
    return {
      staticImgBaseUrl,
    };
  },
  mounted() {},
  methods: {
    handleOrderTypeStoreSelected(storeId) {
      EVENT_CLICK_RESTAURANT_SELECTION({
        sectionName: `${this.dataTitle}, ${this.dataStoreId}`,
        sectionPosition: this.dataIndex + 1,
        category: OrderTypesFromCode[this.selectedOrderType],
        subCategory: this.dataContainerType,
      });
      LocalStorageFunc.resetAllSelectedLocations();
      this.$store.dispatch(keyMapsAction.STORE_DETAILS_API, { storeId });
      this.$store.commit(
        keyMapsMutation.UPDATE_TAKEAWAY_OR_DINEIN_ON_SELECTION,
        this.dataItem
      );
      LocalStorageFunc.updateStoreId(storeId);
      LocalStorageFunc.setDeliveryTypeStationData(this.dataItem?.stations[0]);
      LocalStorageFunc.setSelectedStore(this.dataItem);
      LocalStorageFunc.setSelectedChangedLocationForTwyDinein({});
      Utility.redirectToHomeOrRedirectUrl([
        { name: "changeTriggerFromDineinTwy", value: false },
      ]);
    },
  },
  computed: {
    deliveryTimeInMin() {
      return Math.round(this.dataTime / 60);
    },
    selectedOrderType() {
      return (
        LocalStorageFunc.getSelectedDeliveryType() ||
        this.$store.state.User.currentOrderType
      );
    },
  },
};
</script>

<style></style>
